module.exports = __webpack_public_path__ + "img/tablet.8b52d734.svg";